import initialState from 'src/state'
import * as types from 'src/actions/types'

export default (state = initialState.shouldShowUseCases, action) =>
  action.type === types.SET_SHOULD_SHOW_USE_CASES ? action.payload : state
